<script>
export default {
  name: "keypres",
  props: {
    keyCode: {
      type: Number,
      default: null
    },
    event: {
      type: String,
      default: "keyup"
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    window.addEventListener(this.event, this.emitEvent);
  },
  destroyed() {
    window.removeEventListener(this.event, this.emitEvent);
  },
  methods: {
    emitEvent() {
      if (!this.disabled && (event.keyCode === this.keyCode || !this.keyCode)) {
        this.$emit("pressed", event.keyCode);
      }
    }
  },
  render: () => null
};
</script>

<style scoped></style>
